import React from 'react';
import PropTypes from 'prop-types';

import { Navigate, useParams } from 'react-router-dom';
import { buildTeamPath } from 'utils/teamFromUrl';

export default function Redirect({ to, from }) {
  const { teamKey } = useParams();
  const resolvedTo = teamKey ? buildTeamPath(teamKey, to) : to;
  return <Navigate to={resolvedTo} state={{ from }} replace />;
}

Redirect.propTypes = {
  to: PropTypes.string.isRequired,
  from: PropTypes.string,
};

Redirect.defaultProps = {
  from: undefined,
};
